module.exports = __webpack_public_path__ + "static/media/14.71adf017.png";